var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.66743 8.48457C5.34931 8.21669 5.34931 7.7824 5.66743 7.51451C5.98554 7.24663 6.50126 7.24663 6.81937 7.51451L8.6868 9.08709V0.685714C8.6868 0.3072 9.0516 0 9.50109 0C9.95057 0 10.3154 0.3072 10.3154 0.685714V9.08709L12.1828 7.51451C12.5009 7.24663 13.0166 7.24663 13.3347 7.51451C13.6529 7.7824 13.6529 8.21669 13.3347 8.48457L10.0776 11.2274C9.91909 11.3609 9.71063 11.4286 9.50217 11.4286C9.29371 11.4286 9.08526 11.3618 8.92674 11.2274L5.6696 8.48457H5.66743ZM18.1857 10.0571C17.7362 10.0571 17.3714 10.3643 17.3714 10.7429V13.4857C17.3714 14.1157 16.7623 14.6286 16.0143 14.6286H2.98571C2.23766 14.6286 1.62857 14.1157 1.62857 13.4857V10.7429C1.62857 10.3643 1.26377 10.0571 0.814286 10.0571C0.3648 10.0571 0 10.3643 0 10.7429V13.4857C0 14.8727 1.33869 16 2.98571 16H16.0143C17.6613 16 19 14.8727 19 13.4857V10.7429C19 10.3643 18.6352 10.0571 18.1857 10.0571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.3e227bc5174a8984a57f46b884ba5854.svg";
export { ForwardRef as ReactComponent };